import { action } from 'typesafe-actions';

import ActionTypes from './constants';

// eslint-disable-next-line import/prefer-default-export
export const logout = () => action(ActionTypes.LOGOUT);
